import { LatLonToXYConverter } from './LatLonToXY';
import { PlacesList } from './dataClasses/Places';
import { Portal } from './Portal';
import MainScene from 'src/app/Scenes/MainScene';
import ChunkedScene from './ChunkedScene';

export class LandmarkManager {
  landMarkObjects: Portal[];

  static preload(scene) {
    scene.load.image('cave_exit', 'assets/portals/cave_exit.png');
    scene.load.image('vcuLab', 'assets/portals/vcuLabExterior.png');
    scene.load.image('monroeTomb', 'assets/portals/monroeTomb.png');
    scene.load.image('pumpHouse', 'assets/portals/pumpHouse.png');
    scene.load.image('fousheesMill', 'assets/portals/fousheesMill.png');
    scene.load.image('churchHillTunnel', 'assets/portals/churchHillTunnel.png');
    scene.load.image('restInPieces', 'assets/portals/rip_exterior.png');
    scene.load.image('oldStoneHouse', 'assets/portals/StoneHouseExterior.png');
    scene.load.image('prattsCastle', 'assets/portals/PrattsCastleExterior.png');
    scene.load.image('japaneseHouse', 'assets/portals/japaneseHouse.png');
    scene.load.image('theatreExterior', 'assets/portals/richmondTheatreExterior.png');
    scene.load.image('bellIsleGym', 'assets/portals/BelleIsleGymExterior.png');
    scene.load.image('powerPlant', 'assets/portals/PowerPlant.png');
    scene.load.image('brandtHall', 'assets/portals/BrandtHall.png');
    scene.load.image('fountain', 'assets/portals/fountain.gif');
  }

  create(scene: MainScene) {
    const landmarks = PlacesList.map((place) => {
      let externalCoord = LatLonToXYConverter.latlngToScreenXY(
        place.coords.latitude,
        place.coords.longitude
      );
      let entrance: Portal = new Portal({
        scene: scene,
        x: externalCoord.x,
        y: externalCoord.y,
        width: ChunkedScene.tileWidth*2,
        height: ChunkedScene.tileHeight*2,
        texture: place.imageName,
        portalName: place.name,
        prerequisites: place.prerequisites || null,
        borderless: place.borderless,
        requiresHealth: place.requiresHealth,
        musicTrack: place.musicTrack || null,
      }, 1, true);
    });
  }
}
